import styled, { css } from 'styled-components';

import { overrideAlignmentForMobilePreviewMode } from '../styles/commonStyle';
import { FORM_ALIGNMENT, FORM_LAYOUT_OPTIONS } from '../utils/constants';
import { Enum } from '../utils/types';

interface Padding {
  paddingTop?: number;
  paddingBottom?: number;
  paddingLeft?: number;
  paddingRight?: number;
}
export const WrapperBox = styled.div<{ maxWidth?: number } & Padding>`
  width: ${({ maxWidth }) => (maxWidth ? `min(${maxWidth}px, 100%)` : `min(${605}px, 100%)`)};
  max-height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: ${({ paddingTop = 0 }) => paddingTop}px;
  padding-bottom: ${({ paddingBottom = 0 }) => paddingBottom}px;
  padding-left: ${({ paddingLeft = 0 }) => paddingLeft}px;
  padding-right: ${({ paddingRight = 0 }) => paddingRight}px;
  ::-webkit-scrollbar {
    display: none;
  }
`;

export const Alignment = styled.div<{
  align: Enum<typeof FORM_ALIGNMENT>;
  addPadding?: boolean;
  layout?: Enum<typeof FORM_LAYOUT_OPTIONS>;
}>`
  height: 100%;
  overflow-y: auto;
  display: flex;
  justify-content: center;
  align-items: ${({ align }) =>
    align === 'left' ? 'flex-start' : align === 'right' ? 'flex-end' : 'center'};
  text-align: ${({ align }) => align};
  flex-direction: column;
  padding: ${({ addPadding }) => (addPadding ? '0px 8px' : '0px')};
  width: ${({ addPadding }) => (addPadding ? 'calc(100% - 16px)' : '100%')};
  @media screen and (min-width: 768px) {
    padding: ${({ addPadding }) => (addPadding ? '0px 80px' : '0px')};
    width: ${({ addPadding }) => (addPadding ? 'calc(100% - 160px)' : '100%')};
  }
  ${({ layout }) =>
    layout === FORM_LAYOUT_OPTIONS.SINGLE_STEP_FORM &&
    css`
      /* For small embed we need padding on top to prevent overlapping of sign in and skip to video floating buttons */
      @media only screen and (max-width: 700px) {
        padding-top: 50px;
        height: calc(100% - 50px);
      }
    `}
  ${overrideAlignmentForMobilePreviewMode}
`;

export const Logo = styled.img.attrs(() => ({ alt: 'Logo' }))`
  max-height: 56px;
  margin-top: 10px;
  margin-bottom: 16px;
  margin-left: 8px;
  margin-right: 8px;
`;

export const Divider16 = styled.div`
  height: 16px;
`;
